export default "__VITE_ASSET__CnXwk3OU__"